<script setup lang="ts">
import PhIconButton from '@/components/ui/PhIconButton.vue'
import useLanguage from '@/composables/useLanguage'
import { PhArrowsInSimple, PhArrowsOutSimple } from '@phosphor-icons/vue'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    /** Is the button showing the expand or collapse state? */
    variant: 'collapse' | 'expand'
    /** What text should the tooltip display (if undefined, default is "close")? */
    tooltipText?: string
    /** What should the aria-text be for the button, if different from the tooltip text? */
    ariaLabel?: string
    /** What size should the icon be? (defaults to 24) */
    sizePx?: number
  }>(),
  {
    sizePx: 24
  }
)

defineEmits<{
  (e: 'toggle'): void
}>()

const i18n = useLanguage('UICollapseButton')

const text = computed(
  () =>
    props.tooltipText ??
    (props.variant === 'collapse' ? i18n.value.collapse : i18n.value.expand)
)
</script>

<template>
  <PhIconButton
    :tooltip-text="text"
    tooltip-direction="bottom"
    tooltip-alignment="center"
    class="shrink-0"
    :label="ariaLabel ?? text"
    @click="$emit('toggle')"
  >
    <PhArrowsOutSimple
      v-if="variant === 'expand'"
      :size="sizePx"
      class="fill-charcoal"
      weight="regular"
    />
    <PhArrowsInSimple
      v-else
      :size="sizePx"
      class="fill-charcoal"
      weight="regular"
    />
  </PhIconButton>
</template>
